import { render, staticRenderFns } from "./ready.vue?vue&type=template&id=6dd406f8&scoped=true"
import script from "./ready.vue?vue&type=script&lang=js"
export * from "./ready.vue?vue&type=script&lang=js"
import style0 from "./ready.vue?vue&type=style&index=0&id=6dd406f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd406f8",
  null
  
)

export default component.exports